import { createFileRoute, useNavigate } from '@tanstack/react-router';
import NewResearchPage from '@/pages/NewResearchPage.jsx';

function NewResearchRoute() {
  const navigate = useNavigate();
  const backToList = () => navigate({ to: '/research-profiles' });
  return <NewResearchPage onCancel={backToList} onSubmitted={backToList} />;
}

export const Route = createFileRoute('/research-profiles/new')({ component: NewResearchRoute });
